"use client"
import { useEffect } from "react"
import { useMetricDetails } from "./metricDetailsContext"
import { useMetricHoverSwap } from "../blocks/metrics/metricHoverSwap"
import { usePolicyHoverSwap } from "../blocks/policy/policyHoverSwap"
import { usePowerHoverSwap } from "../blocks/power/powerHoverSwap"
import { useLaborHoverSwap } from "../blocks/labor/laborHoverSwap"
import { useCapabilityHoverSwap } from "../blocks/capability/capabilityHoverSwap"

// The metric detail open/close choreography is the SEQUENTIAL FADE: the
// leaving HUD layer fades fully out, then the arriving one fades in — no
// crossfade, nothing travels. The fade itself is plain Tailwind classes on
// the two layer divs in Playbook.tsx (HudShellContainer) per the repo's
// keep-classes-inline rule; this module holds the one React-side piece:

// Clears every HUD hover-swap the moment a metric detail opens, so nothing
// that was red from hover (the metric's red chip, a red-filled treemap group,
// a red policy square, the ladder takeover) is still red while the open
// animation plays. Render inside ALL the hover-swap providers (see
// makeBelowDetailHudBody); close is untouched — hover re-arms normally.
//
// Effect deps are the SETTERS (useState setters are identity-stable), not the
// context values — four of the five providers rebuild their context object on
// every render, and depending on those would re-fire this effect on every
// hover flip anywhere in the HUD. With setter deps it runs once per open.
//
// This is deliberately a clear-EVERYTHING list, unlike the targeted
// arrival-side cross-clears in hoverSwapStickyZone.tsx / PoliciesPanel.tsx —
// when adding a sixth hover-swap family, add its setter here too.
export const ClearHudHoversWhileDetailOpen = () => {
  const { openId } = useMetricDetails()
  const setHoveredMetric = useMetricHoverSwap()?.setHoveredMetric
  const policySwap = usePolicyHoverSwap()
  const setHoveredPolicyId = policySwap?.setHoveredPolicyId
  const setHoveredStatus = policySwap?.setHoveredStatus
  const setHoveredPowerItem = usePowerHoverSwap()?.setHoveredItem
  const setLaborHovered = useLaborHoverSwap()?.setHovered
  const setHoveredCapabilityPoint = useCapabilityHoverSwap()?.setHoveredPoint
  useEffect(() => {
    if (!openId) return
    setHoveredMetric?.(null)
    setHoveredPolicyId?.(null)
    setHoveredStatus?.(null)
    setHoveredPowerItem?.(null)
    setLaborHovered?.(false)
    setHoveredCapabilityPoint?.(null)
  }, [
    openId,
    setHoveredMetric,
    setHoveredPolicyId,
    setHoveredStatus,
    setHoveredPowerItem,
    setLaborHovered,
    setHoveredCapabilityPoint,
  ])
  return null
}
